"use client";

import { FieldContainer } from "./FieldContainer";
import { FieldLabel } from "./FieldLabel";
import { useFieldContext } from "../hooks/form-context";
import { Checkbox } from "@ui/components/core/Checkbox";

export interface FormCheckboxProps {
  name: string;
  label: React.ReactNode;
  required?: boolean;
  showTestVariant?: boolean;
}

/**
 * Form-connected Checkbox that integrates with TanStack Form via `useFieldContext`.
 * Follows the same error-display pattern as Input and Textarea.
 */
export const FormCheckbox = ({ name, label, required, showTestVariant }: FormCheckboxProps) => {
  const field = useFieldContext();

  return (
    <FieldContainer>
      <div className='tw-flex tw-items-start tw-gap-2'>
        <div className='tw-pt-0.5'>
          <Checkbox
            id={name}
            name={name}
            isRequired={required}
            isSelected={field.state.value as boolean}
            onChange={value => field.handleChange(value)}
            size='lg'
          />
        </div>
        <FieldLabel
          label={label}
          htmlFor={name}
          required={required}
          layout='checkbox'
          showTestVariant={showTestVariant}
        />
      </div>
    </FieldContainer>
  );
};
